import Lenis from '@studio-freight/lenis'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);
import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
Swiper.use([EffectFade]);

const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	// カスタムプロパティの値を更新する
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};

setScrollbarWidth();


const body = document.querySelector('body');
const btn = document.querySelector('.menuBtn');
const menu_target = document.querySelector('.fixed-menu');
const menu_overlay = document.querySelector('.fixed-menu__overlay');
const hlbtn = document.querySelector('.menuBtn');
const hlbtn__Close = document.querySelector('.fixed-menu__close');
const searchbtn = document.querySelector('.header__search-btn');

const anchorLinks = document.querySelectorAll('a[href^="#"]');
const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
const header = document.querySelector('.header');
const anchorHash = location.hash;

const nowPath = location.pathname;
const headerNavLi = document.querySelectorAll('.header__nav a');

let scrollpos;

function menuOpenAnim(target) {
	hlbtn.setAttribute('aria-expanded', 'true');
	gsap.to(menu_target, {
		ease: "expo.out",
		duration: 0,
		autoAlpha: 1,
		display: "flex"

	});

	scrollpos = window.scrollY;
	body.style.top = scrollpos * -1 + 'px';
	body.classList.add('fixed');
	body.style.paddingRight = window.innerWidth - document.body.clientWidth + 'px';
}
function menuCloseAnim(target) {
	hlbtn.setAttribute('aria-expanded', 'false');

	//menu_target.setAttribute('aria-hidden', 'true');
	gsap.to(menu_target, {
		ease: "expo.out",
		duration: 0,
		autoAlpha: 0,
		display: "none"
	});
	body.classList.remove('fixed');
	body.style.top = 0 + 'px';
	body.style.paddingRight = '0px';
	window.scrollTo(0, scrollpos);
}
function headerActive() {
	headerNavLi.forEach(link => {
		link.removeAttribute('aria-current');
	});
	if (nowPath == "/") {
		headerNavLi[0].setAttribute('aria-current', 'page');
	} else if (nowPath.indexOf("column") == 1) {
		headerNavLi[3].setAttribute('aria-current', 'page');
	} else if (nowPath.indexOf("case") == 1) {
		headerNavLi[4].setAttribute('aria-current', 'page');
	} else if (nowPath.indexOf("service") == 1) {
		headerNavLi[5].setAttribute('aria-current', 'page');
	} else if (nowPath.indexOf("avsystem") == 1) {
		headerNavLi[1].setAttribute('aria-current', 'page');
	} else if (nowPath.indexOf("office-construction") == 1) {
		headerNavLi[2].setAttribute('aria-current', 'page');
	}

}



headerActive();

window.addEventListener("pageshow", function () {

	//lenis.scrollTo("html", 'duration:0');

	//console.log(lenis);

	/*if (window.innerWidth < 761) {
		document.querySelector(".fixed-menu .search-box details").open = false;
	}*/

	//ヘッダーボタン
	hlbtn.addEventListener("click", function () {

		if (hlbtn.getAttribute('aria-expanded') == 'false') {
			menuOpenAnim(this);
		} else {
			menuCloseAnim(this);
		}
	});


	searchbtn.addEventListener("click", function () {
		menuOpenAnim(this);
	});

	//ヘッダーボタン
	hlbtn__Close.addEventListener("click", function () {
		menuCloseAnim(this);
	});
	menu_overlay.addEventListener("click", function () {
		menuCloseAnim(this);
	});

	if (anchorHash) {
		window.scrollTo({
			top: 0,
			behavior: "instant"
		});
		const targetElement = document.querySelector(anchorHash);
		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
		const headerHeight = header.offsetHeight;
		const totalScrollAmount = targetOffsetTop - headerHeight;

		targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		var tm = 500;
		//setTimeout(fn, tm);
	}
	anchorLinksArr.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const targetId = link.hash;
			const targetElement = document.querySelector(targetId);
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			const headerHeight = 0;
			//const totalScrollAmount = targetOffsetTop - headerHeight;
			const totalScrollAmount = targetOffsetTop - headerHeight;
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	});


	const hDropMenuBtns = document.querySelectorAll('.--js-drop');
	//const hDropMenuOverlay = document.querySelector('.header__overlay');

	hDropMenuBtns.forEach((btn, index) => {
		btn.addEventListener("mouseover", function () {
			if (window.innerWidth > 700) {
				//stopLenis()
			}

			//hDropMenuOverlay.setAttribute('aria-hidden', 'false');
			btn.querySelector("a").setAttribute('aria-expanded', 'true');
			btn.querySelector(".--js-drop__inner").setAttribute('aria-hidden', 'false');
			//btn.setAttribute('aria-label', btnLabel);
		});
		btn.addEventListener("mouseleave", function () {
			if (window.innerWidth > 700) {
				//startLenis();
			}

			//hDropMenuOverlay.setAttribute('aria-hidden', 'true');
			btn.querySelector("a").setAttribute('aria-expanded', 'false');
			btn.querySelector(".--js-drop__inner").setAttribute('aria-hidden', 'true');

			//btnLabel = btnLabel.replace("閉じる", "開く");
			//btn.querySelector(".inner").setAttribute('aria-label', btnLabel);
		});

	});



	//
	/*
	const viewAnimTarget = document.querySelectorAll('[data-view-cont="true"]');

	viewAnimTarget.forEach((cont) => {
		let viewAnimItem = cont.querySelectorAll('[data-view-item]');
		//let viewAnimItemLength = viewAnimItem.length;

		const viewTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: cont,
				start: "top center",
				//markers:true,
			},
		});

		viewTimeline.fromTo(
			viewAnimItem,
			{
				autoAlpha: 0,
				y: 30
			},
			{
				y: 0,
				autoAlpha: 1,
				duration: .4,
				stagger: {
					each: .1,
				}
			},

		);

		viewAnimItem.forEach((item) => {
			//console.log(item);
		});
	});*/
	const searchClear = document.querySelectorAll('.searchClearBtn');
	searchClear.forEach(btn => {

		btn.addEventListener('click', e => {
			const searchForm = document.querySelectorAll('.search-box');

			searchForm.forEach(form => {

				form.querySelectorAll("input").forEach(item => {
					if (item.type == 'text') {
						item.value = '';
					}
					if (item.type == 'checkbox') {
						item.checked = false;
					}
				});
				form.querySelectorAll("option").forEach(item => {
					item.selected = false;
				});
			});
		});
	});




	const topCaseBtns = document.querySelectorAll('.caseBtn01');
	const topCaseTargets = document.querySelectorAll('.caseTarget01');

	topCaseBtns.forEach((btn, index) => {
		btn.addEventListener('click', e => {
			topCaseBtns.forEach((btn,index) => {
				btn.setAttribute('aria-expanded', 'false');
				topCaseTargets[index].setAttribute('aria-hidden', 'true');
			});
			if (btn.getAttribute('aria-expanded') == "false") {
				btn.setAttribute('aria-expanded', 'true');
				topCaseTargets[index].setAttribute('aria-hidden', 'false');
			} else {
				btn.setAttribute('aria-expanded', 'false');
				topCaseTargets[index].setAttribute('aria-hidden', 'true');
			}
		});
	});


	const topCaseBtns2 = document.querySelectorAll('.caseBtn02');
	const topCaseTargets2 = document.querySelectorAll('.caseTarget02');

	topCaseBtns2.forEach((btn, index) => {
		btn.addEventListener('click', e => {
			topCaseBtns2.forEach((btn,index) => {
				btn.setAttribute('aria-expanded', 'false');
				topCaseTargets2[index].setAttribute('aria-hidden', 'true');
			});
			if (btn.getAttribute('aria-expanded') == "false") {
				btn.setAttribute('aria-expanded', 'true');
				topCaseTargets2[index].setAttribute('aria-hidden', 'false');
			} else {
				btn.setAttribute('aria-expanded', 'false');
				topCaseTargets2[index].setAttribute('aria-hidden', 'true');
			}
		});
	});

});
window.addEventListener("resize", function () {
	setScrollbarWidth();
});
